
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartManualUpdateIec as ObiChartManualUpdateIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-manual-update-iec.js';
 
 
 

 
 export const ObiChartManualUpdateIec = createComponent({
   react: React,
   tagName: 'obi-chart-manual-update-iec',
   elementClass: ObiChartManualUpdateIecElement,
   events: {
     
   }
  });
 
 